// zod is configured before any schema is built (zod-config.ts). A bundler hoists the chunks
// an entry imports above the entry's own code, so the app loads after it, dynamically.
import './zod-config';

void import('./bootstrap');
